import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import AuthLayout from '@/views/Pages/AuthLayout.vue';
import NotFound from '@/views/GeneralViews/NotFoundPage.vue';

const Segments = () => import(/* webpackChunkName: "extra" */ '@/views/Segments/List.vue');
const Subscribers = () => import(/* webpackChunkName: "extra" */ '@/views/Subscribers/List.vue');
const SubscriberDetail = () => import(/* webpackChunkName: "extra" */ '@/views/Subscribers/Detail.vue');
const PushNotifications = () => import(/* webpackChunkName: "extra" */ '@/views/PushNotifications/List.vue');
const PushNotificationStatistics = () => import(/* webpackChunkName: "extra" */ '@/views/PushNotifications/Statistics');
const PushNotificationsV2Upsert = () => import(/* webpackChunkName: "extra" */ '@/views/PushNotifications/v2/Upsert.vue');
const InAppNotificationDetail = () => import(/* webpackChunkName: "extra" */ '@/views/InAppNotifications/Create.vue');
const InAppNotifications = () => import(/* webpackChunkName: "extra" */ '@/views/InAppNotifications/List.vue');

// Calendar
const Calendar = () => import(/* webpackChunkName: "extra" */ '@/views/Calendar/Calendar.vue');

// Charts
const Charts = () => import(/* webpackChunkName: "dashboard" */ '@/views/Charts.vue');

// Components pages
const Buttons = () => import(/* webpackChunkName: "components" */ '@/views/Components/Buttons.vue');
const Cards = () => import(/* webpackChunkName: "components" */ '@/views/Components/Cards.vue');
const GridSystem = () => import(/* webpackChunkName: "components" */ '@/views/Components/GridSystem.vue');
const Notifications = () => import(/* webpackChunkName: "components" */ '@/views/Components/Notifications.vue');
const Icons = () => import(/* webpackChunkName: "components" */ '@/views/Components/Icons.vue');
const Typography = () => import(/* webpackChunkName: "components" */ '@/views/Components/Typography.vue');

// Dashboard pages
const Dashboard = () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard/Dashboard.vue');
const AlternativeDashboard = () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard/AlternativeDashboard.vue');
const Widgets = () => import(/* webpackChunkName: "dashboard" */ '@/views/Widgets.vue');

// Forms pages
const FormElements = () => import(/* webpackChunkName: "forms" */ '@/views/Forms/FormElements.vue');
const FormComponents = () => import(/* webpackChunkName: "forms" */ '@/views/Forms/FormComponents.vue');
const FormValidation = () => import(/* webpackChunkName: "forms" */ '@/views/Forms/FormValidation.vue');

// Maps pages
const GoogleMaps = () => import(/* webpackChunkName: "extra" */ '@/views/Maps/GoogleMaps.vue');
const VectorMaps = () => import(/* webpackChunkName: "extra" */ '@/views/Maps/VectorMaps.vue');

// Pages
const User = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/UserProfile.vue');
const Pricing = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Pricing.vue');
const TimeLine = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/TimeLinePage.vue');
const Login = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Login.vue');
const ViaToken = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/ViaTokenLogin.vue');
const Home = () => import(/* webpackChunkName: "pages" */ '@/views/Dashboard/Home.vue');
const Register = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Register.vue');
const Lock = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Lock.vue');

// TableList pages
const RegularTables = () => import(/* webpackChunkName: "tables" */ '@/views/Tables/RegularTables.vue');
const SortableTables = () => import(/* webpackChunkName: "tables" */ '@/views/Tables/SortableTables.vue');
const PaginatedTables = () => import(/* webpackChunkName: "tables" */ '@/views/Tables/PaginatedTables.vue');

// Settings
const SettingsAPIKeys = () => import(/* webpackChunkName: "settings" */ '@/views/Settings/ApiKeys/index.vue');
const Applications = () => import(/* webpackChunkName: "settings" */ '@/views/Settings/Applications/list.vue');

let componentsMenu = {
  path: '/components',
  component: DashboardLayout,
  redirect: '/components/buttons',
  name: 'Components',
  children: [
    {
      path: 'buttons',
      name: 'Buttons',
      component: Buttons
    },
    {
      path: 'cards',
      name: 'Cards',
      component: Cards
    },
    {
      path: 'grid-system',
      name: 'Grid System',
      component: GridSystem
    },
    {
      path: 'notifications',
      name: 'Notifications',
      component: Notifications
    },
    {
      path: 'icons',
      name: 'Icons',
      component: Icons
    },
    {
      path: 'typography',
      name: 'Typography',
      component: Typography
    }
  ]
};

let formsMenu = {
  path: '/forms',
  component: DashboardLayout,
  redirect: '/forms/elements',
  name: 'Forms',
  children: [
    {
      path: 'elements',
      name: 'Form elements',
      component: FormElements
    },
    {
      path: 'components',
      name: 'Form components',
      component: FormComponents
    },
    {
      path: 'validation',
      name: 'Form validation',
      component: FormValidation
    }
  ]
};

let tablesMenu = {
  path: '/tables',
  component: DashboardLayout,
  redirect: '/table/regular',
  name: 'Tables menu',
  children: [
    {
      path: 'regular',
      name: 'Tables',
      component: RegularTables
    },
    {
      path: 'sortable',
      name: 'Sortable',
      component: SortableTables
    },
    {
      path: 'paginated',
      name: 'Paginated Tables',
      component: PaginatedTables
    }
  ]
};

let mapsMenu = {
  path: '/maps',
  component: DashboardLayout,
  name: 'Maps',
  redirect: '/maps/google',
  children: [
    {
      path: 'google',
      name: 'Google Maps',
      component: GoogleMaps
    },
    {
      path: 'vector',
      name: 'Vector Map',
      component: VectorMaps
    }
  ]
};

let pagesMenu = {
  path: '/pages',
  component: DashboardLayout,
  name: 'Pages',
  redirect: '/pages/user',
  children: [
    {
      path: 'user',
      name: 'User Page',
      component: User
    },
    {
      path: 'timeline',
      name: 'Timeline Page',
      component: TimeLine
    }
  ]
};

let authPages = {
  path: '/',
  component: AuthLayout,
  name: 'Authentication',
  children: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/via-login-token',
      name: 'ViaToken',
      component: ViaToken,
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/pricing',
      name: 'Pricing',
      component: Pricing
    },
    {
      path: '/lock',
      name: 'Lock',
      component: Lock
    },
    {
      path: '*',
      component: NotFound
    }
  ]
};

let audienceMenu = {
  path: '/audience',
  component: DashboardLayout,
  redirect: '/segments',
  name: 'Audience',
  children: [
    {
      path: 'segments',
      name: 'Segment List',
      component: Segments
    },
    {
      path: 'segments/:id',
      name: 'Segment Detail',
      component: Segments
    },
    {
      path: 'subscribers',
      name: 'Subscriber List',
      component: Subscribers
    },
    {
      path: 'subscribers/:id',
      name: 'Subscriber Detail',
      component: SubscriberDetail
    },
  ]
};

let channelMenu = {
  path: '/channel',
  component: DashboardLayout,
  redirect: '/channel/push-notifications',
  name: 'Channel',
  children: [
    {
      path: 'push-notifications',
      name: 'Push Notifications',
      component: PushNotifications
    },
    {
      path: 'push-notifications/create',
      name: 'Push Notification Create',
      component: PushNotificationsV2Upsert
    },
    {
      path: 'push-notifications/:id',
      name: 'Push Notification Edit',
      component: PushNotificationsV2Upsert
    },
    {
      path: 'push-notifications/:id/statistics',
      name: 'Push Notification Statistics',
      component: PushNotificationStatistics
    },
    {
      path: 'push-notifications/:id/statistics',
      name: 'Push Notification Statistics',
      component: PushNotificationStatistics
    },
    {
      path: 'in-app-notifications',
      name: 'In App Notifications',
      component: InAppNotifications
    },
    {
      path: 'in-app-notifications/:id',
      name: 'In App Notification Detail',
      component: InAppNotificationDetail
    },
  ]
};

const settingsMenu = {
  // TODO: create general settings page.
  path: '/settings',
  component: DashboardLayout,
  redirect: '/settings/api-keys',
  name: 'Settings',
  children: [{
    path: 'api-keys',
    name: 'API Keys',
    component: SettingsAPIKeys,
  },
    {
      path: 'applications',
      name: 'Applications',
      component: Applications,
    }],
};

const routes = [
  {
    path: '/',
    redirect: '/home',
    name: 'Home'
  },
  componentsMenu,
  formsMenu,
  tablesMenu,
  mapsMenu,
  pagesMenu,
  audienceMenu,
  channelMenu,
  settingsMenu,
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/ai',
    name: 'Qulerts',
    children: [
      {
        path: 'ai',
        name: 'AI',
        component: Dashboard,
      },
      {
        path: '/home',
        name: 'Home',
        component: Home,
        meta: {
          noBodyBackground: true
        }
      },
      {
        path: 'alternative',
        name: 'Alternative',
        component: AlternativeDashboard,
        meta: {
          navbarType: 'light'
        }
      },
      {
        path: 'calendar',
        name: 'Calendar',
        component: Calendar
      },
      {
        path: 'charts',
        name: 'Charts',
        component: Charts
      },
      {
        path: 'widgets',
        name: 'Widgets',
        component: Widgets
      }
    ]
  },
  authPages,
];

export default routes;
